import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import PagedPreviewTable from '../PagedPreviewTable';
import {
  getDatasetName,
  getDatasetType,
  getFilteredDataset,
  getSelectedParameters,
  getFrequencyDataSetLength
} from 'store/dataset';

import { addRowIndexAndHandleEmptyCell, formatFrequencyColumnHeadersForMaterialTable } from '../helper';
import {
  FREQUENCY,
  CONTINGENCY,
  RELATIVE_FREQUENCY
} from 'scenes/Dataset/components/constants';


const FrequencyPreviewTableComponent = ({ nameForColumns }) => {
  const parameters = useSelector(state => getSelectedParameters(state));
  const filteredDataset = useSelector(state => getFilteredDataset(true)(state));
  const nameOfTable = useSelector(state => getDatasetName(state));
  const typeOfDataset = useSelector(state => getDatasetType(state));
  const frequencyLength = useSelector(state => getFrequencyDataSetLength(state));

  const columns = formatFrequencyColumnHeadersForMaterialTable(filteredDataset, parameters, ['additionalData'], nameForColumns);
  const formattedData = addRowIndexAndHandleEmptyCell(filteredDataset);

  const typeOfDatasetText = () => {
    if (typeOfDataset === RELATIVE_FREQUENCY) {
      return frequencyLength === 1 ? FREQUENCY : CONTINGENCY;
    }
    return typeOfDataset;
  };

  return (
    <div data-testid="preview-table">
      <h2 className="sub-header-page">
        {nameOfTable}
      </h2>
      <p className="text-capitalize">
        {typeOfDatasetText()} table
      </p>
      <div id="previewTable">
        <PagedPreviewTable
          columns={columns}
          data={formattedData}
          isFrequencyTable
        />
      </div>
    </div>
  );
};

FrequencyPreviewTableComponent.propTypes = {
  nameForColumns: PropTypes.string.isRequired
};

export default FrequencyPreviewTableComponent;
